import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';

export default class LastNewsList {
    constructor() {
        this.sections = document.querySelectorAll('.block-last-news-list');
        this.ready();
    }

    ready() {
        if (this.sections.length > 0) {
            this.sections.forEach((section) => {
                this.slider = section.querySelector('.swiper');
                this.pagination = section.querySelector('.swiper-pagination');

                new Swiper(this.slider, {
                    modules: [Pagination],
                    grabCursor: false,
                    allowTouchMove: true,
                    slidesPerView: "auto",
                    pagination: {
                        el: this.pagination,
                        clickable: true,
                        type: 'bullets'
                    },
                    breakpoints: {
                        0: {
                            spaceBetween: 12,
                            slidesOffsetAfter: 16,
                            slidesOffsetBefore: 16,
                        },
                        1024: {
                            spaceBetween: 36,
                            slidesOffsetAfter: 0,
                            slidesOffsetBefore: 0,
                        },
                    },
                });

            })
        }
    }
}

if (document.querySelector('.block-last-news-list')) {
    new LastNewsList();
}